<template>
<x-y-chart
  v-if="dataList[0]"
  :data-config="dataList[0]"
  :unit-prop="unitProp"
  chart-type="bar"
  :stack-type="0"
  data-time-format="MM月DD日HH时"
  download-name="PM2.5和重金属"
  chart-min-height="300px"
  chart-height="auto"
  style="height:100%;padding: 10px;"
/>
</template>

<script>
import BaseCompare from './BaseCompare'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'AuditHeavyMetalDeviceCompareChart',
  extends: BaseCompare,
  components: {XYChart},
  props: {
    conditions: {
      required: true,
      type: Object
    }
  },
  computed: {
    completeAllData: () => true,
    otherSiteDeviceCategoryConfigs: () => [
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1008'))
    ]
  },
  data () {
    return {
      unitProp: 'stdUnit'
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let siteId = dimensionIds[dimension]
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '1008') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        return {
          type: 'bar',
          stack: siteId,
          barMaxWidth: 30
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditHeavyMetalDeviceCompareChart.vue